import { render, staticRenderFns } from "./dataSet.vue?vue&type=template&id=674c1a80&scoped=true"
import script from "./dataSet.vue?vue&type=script&lang=js"
export * from "./dataSet.vue?vue&type=script&lang=js"
import style0 from "./dataSet.vue?vue&type=style&index=0&id=674c1a80&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "674c1a80",
  null
  
)

export default component.exports